export default "assets/images/contact-phone-en-31da0302.png";